import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "33e3ea8b-dde9-491e-8aec-3aa35133d044",
    content: "Binaural hearing improves sound source localization",
    options: {},
  },
  {
    id: "c7abe238-5f99-423e-9cf7-045a846122fa",
    content: "Binaural hearing improves the segregation of different sound sources",
    options: {},
  },
  {
    id: "6aabeed8-098b-48af-9a2e-d983b075a485",
    content: "Binaural hearing improves speech intelligibility in noisy environments",
    options: {},
  },
  {
    id: "249c0faf-620b-4647-a42c-79d7d9b55cf2",
    content: "Binaural hearing protects the ear against loud noises",
    options: {},
  },
  {
    id: "e4ca70e8-c7cd-4a6a-b0fb-25bdf8125999",
    content: "Binaural hearing is independent from individual anatomical features",
    options: {},
  },
  { id: "04b5bd16-3e15-44f2-8f49-af3d93ac6dea", content: "Binaural hearing improves with age", options: {} },
];

export const task: Task = {
  id: "978f7e09-623a-450b-8a80-772cd66676f3",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "33e3ea8b-dde9-491e-8aec-3aa35133d044",
    "c7abe238-5f99-423e-9cf7-045a846122fa",
    "6aabeed8-098b-48af-9a2e-d983b075a485",
  ],
};
